import { useEffect } from 'react'
import { Style, styled } from 'inlines'
import Column from '@app/components/layout/Column'
import { Button, type ButtonProps } from '@app/components/core/button/Button'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import Row from '@app/components/layout/Row'

const overlayStyle: Style = {
  position: 'fixed',
  inset: 0,
  zIndex: 7,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background:
    'linear-gradient(180deg, rgba(255, 255, 255, 0.40) 6.87%, rgba(255, 255, 255, 0.72) 25.42%, #FFF 94.2%)',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
}

export type LockedPageCoverProps = {
  title?: string
  body?: string
  buttonProps?: ButtonProps[]
  style?: Style
}

export const LockedPageCover = ({
  title,
  body,
  buttonProps,
  style,
}: LockedPageCoverProps) => {
  useEffect(() => {
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = prev
    }
  }, [])

  return (
    <styled.div style={{ ...overlayStyle, ...style }}>
      <Column
        alignItems="center"
        gap="1.5rem"
        style={{
          width: '100%',
          maxWidth: '95vh',
          padding: '2rem',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        {title !== undefined && title !== null && <Title.H2>{title}</Title.H2>}
        {body !== undefined && body !== null && (
          <Text.Medium style={{ marginBottom: '1.5rem' }}>{body}</Text.Medium>
        )}
        {buttonProps && (
            <Row>
              {[...buttonProps]
                .map((button, index) => (
                  <Button
                    key={`${button.label}-${index}`}
                    size={button.size}
                    label={button.label}
                    onClick={button.onClick}
                    variant={button.variant}
                    icon={button.icon}
                    iconPosition={button.iconPosition}
                  />
                ))}
            </Row>
          )}
      </Column>
    </styled.div>
  )
}
